import { render, staticRenderFns } from "./OrderNotificationNewPopup.vue?vue&type=template&id=237691b6&"
import script from "./OrderNotificationNewPopup.vue?vue&type=script&lang=js&"
export * from "./OrderNotificationNewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports